/** @format */

import React, { Component } from 'react';
import RequestPart from './RequestPart/RequestPart';
import './RequestParts.css';

import { inject, observer } from 'mobx-react';

@inject('UserStore', 'RequestsStore')
@observer
class RequestParts extends Component {
  renderParts = () => {
    const { RequestsStore, UserStore } = this.props;
    let parts = RequestsStore.currentRequest.reqParts;
    let partsKeys = Object.keys(parts);
    return partsKeys
      .filter(partKey => {
        const part = parts[partKey];

        return (
          (part !== null &&
            part !== undefined &&
            UserStore.user.role === 'warehouse' &&
            UserStore.user.whZone !== 'all' &&
            part.data.whCode === UserStore.user.whZone) ||
          UserStore.user.role !== 'warehouse' ||
          UserStore.user.whZone === 'all'
        );
      })
      .map(partKey => <RequestPart key={partKey} partId={partKey} />);
  };
  render() {
    return <div>{this.renderParts()}</div>;
  }
}

export default RequestParts;
